import React, { useEffect, useState, useCallback } from "react";
import api from "../services/api";
import { FiCheckCircle, FiTrash } from "react-icons/fi";
import '../css/AdminQuestionReviewPage.css';

export default function AdminQuestionsReviewPage() {
  const [questions, setQuestions] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("pending");
  const [page, setPage] = useState(1);
  const [perPage] = useState(30);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState("");

  // useCallback so fetchQuestions reference doesn't change
  const fetchQuestions = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        status,
        ...(search ? { search } : {}),
        page,
        per_page: perPage,
      }).toString();
      const res = await api.get(`/admin/questions/review?${params}`);
      setQuestions(res.data.rows || []);
      setTotal(res.data.total || 0);
      setError("");
    } catch (err) {
      setError("Failed to fetch questions for review.");
    }
    setLoading(false);
  }, [status, search, page, perPage]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  const approveQuestion = async (id) => {
    setActionLoading(true);
    try {
      await api.patch(`/admin/questions/${id}/approve`);
      fetchQuestions();
    } catch {
      alert("Failed to approve question.");
    }
    setActionLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this question? This cannot be undone.")) return;
    setActionLoading(true);
    try {
      await api.delete(`/admin/questions/${id}`);
      fetchQuestions();
    } catch {
      alert("Failed to delete question.");
    }
    setActionLoading(false);
  };

  const totalPages = Math.ceil(total / perPage);

  return (
    <div className="admin-container">
      <div className="admin-header">
  <h2>Questions Pending Review</h2>
  <input
    value={search}
    onChange={e => { setPage(1); setSearch(e.target.value); }}
    placeholder="Search questions…"
    type="text"
  />
  <select value={status} onChange={e => { setPage(1); setStatus(e.target.value); }}>
    <option value="pending">Pending</option>
    <option value="approved">Approved</option>
    <option value="rejected">Rejected</option>
  </select>
</div>
      {error && <div className="error-message">{error}</div>}

      <div style={{ minHeight: 240 }}>
        {loading ? <div>Loading…</div> : (
          <table className="admin-table" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Question</th>
                <th>Category</th>
                <th>Status</th>
                <th>Timestamp</th>
                <th style={{ minWidth: 110 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {questions.length === 0 ? (
                <tr><td colSpan={6}>No questions found.</td></tr>
              ) : questions.map(q => (
                <tr key={q.id}>
  <td data-label="ID">{q.id}</td>
  <td className="question-cell" data-label="Question">{q.question_text}</td>
  <td data-label="Category">{q.category_name || "—"}</td>
  <td data-label="Status">
    {q.status === "approved" ? (
      <span className="status-pill approved">Approved</span>
    ) : q.status === "rejected" ? (
      <span className="status-pill rejected">Rejected</span>
    ) : (
      <span className="status-pill pending">Pending</span>
    )}
  </td>
  <td data-label="Timestamp">{q.timestamp ? new Date(q.timestamp).toLocaleString() : ""}</td>
  <td className="actions-cell" data-label="Actions">
    {q.status !== "approved" && (
      <button
        className="link-btn approve"
        title="Approve"
        onClick={() => approveQuestion(q.id)}
        disabled={actionLoading}
      >
        <FiCheckCircle /> Approve
      </button>
    )}
    <button
      className="link-btn delete"
      title="Delete"
      onClick={() => handleDelete(q.id)}
      disabled={actionLoading}
    >
      <FiTrash /> Delete
    </button>
  </td>
</tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
     <div className="pagination">
  {Array.from({ length: totalPages }, (_, i) => (
    <button
      key={i}
      className={`page-btn${page === i + 1 ? " active" : ""}`}
      onClick={() => setPage(i + 1)}
      disabled={page === i + 1}
    >
      {i + 1}
    </button>
        ))}
      </div>
    </div>
  );
}
